import AuthForm from '../../components/auth/auth';
import useEmail from './hooks/use-email';

const Email = (): React.JSX.Element => {
  const {
    globalError,
    control,
    onSubmit,
    setForgotPasswordVisible,
    requestInProgress,
    forgotPasswordVisible,
    errors,
  } = useEmail();

  return (
    <AuthForm
      globalError={globalError}
      control={control}
      onSubmit={onSubmit}
      toggleShowForgotPass={setForgotPasswordVisible}
      requestInProgress={requestInProgress}
      forgotPasswordVisible={forgotPasswordVisible}
      errors={errors}
    />
  );
};

export default Email;
